import VueRouter from 'vue-router'

// import { requireAuth, logout, pathRedirect } from '@/utils/auth'
import { requireAuth, logout } from '@/utils/auth'
import Home from '@/containers/Home'
import Login from '@/containers/Login'
import NotFound from '@/containers/Common/NotFound'

import baseRoutes from './base'
import systemRoutes from './system'
import dashboardRoutes from './dashboard'
import businessChargesRoutes from './businessCharges'
import meterReadingRoutes from './meterReading'
import telnetReadingRoutes from './telnetReading'
import nbRoutes from './nb'
import noticeRoutes from './notice'
import leakageControlRoutes from './leakageControl'
import wechatBusinessHallRoutes from './wechatBusinessHall'
import settingRoutes from './setting'
import exceptRoutes from './except'

const routes = [
  { path: '/',
    component: Home,
    children: [
      baseRoutes,
      systemRoutes,
      dashboardRoutes,
      businessChargesRoutes,
      meterReadingRoutes,
      telnetReadingRoutes,
      nbRoutes,
      noticeRoutes,
      leakageControlRoutes,
      wechatBusinessHallRoutes,
      settingRoutes,
      exceptRoutes
    ],
    // redirect: pathRedirect,
    redirect: '/system/welcome',
    beforeEnter: requireAuth
  },
  { path: '/login', component: Login },
  { path: '/logout',
    beforeEnter (to, from, next) {
      logout()
      next('/login')
    }
  },
  { path: '*', component: NotFound }
]

const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  routes: routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js